import { QueryClient, useQuery } from '@tanstack/react-query';

import { GetFixVoorschrift200 } from '@/api/generated/digiVAPI.schemas';
import { useVoorschrift } from '@/api/queries/objects';

type UseMinBeginGeldigheidProps = {
  bedrijfId: string;
};

const getMinBeginGeldigheidQueryOptions = ({
  bedrijfId,
}: UseMinBeginGeldigheidProps) => {
  return useVoorschrift.getOptions(
    {
      page: 1,
      size: 1,
      filter: [
        {
          model: 'Bedrijf',
          field: 'ID',
          op: 'eq',
          value: bedrijfId,
        },
        {
          model: 'Voorschrift',
          field: 'Stop_Lineage',
          op: 'eq',
          value: '0',
        },
        {
          model: 'Voorschrift',
          field: 'Ontwerp',
          op: 'eq',
          value: '0',
        },
      ],
      sort: [
        {
          model: 'Voorschrift',
          field: 'Begin_Geldigheid',
          direction: 'asc',
        },
      ],
    },
    {
      select: selectMinBeginGeldigheid,
    }
  );
};

const selectMinBeginGeldigheid = ({ objects }: GetFixVoorschrift200) => {
  const minBeginGeldigheid = objects?.[0]?.Begin_Geldigheid;

  const now = new Date();
  now.setHours(0, 0, 0, 0);

  return minBeginGeldigheid ? new Date(minBeginGeldigheid) : now;
};

export const ensureQueryDataMinBeginGeldigheid = async ({
  bedrijfId,
  queryClient,
}: UseMinBeginGeldigheidProps & { queryClient: QueryClient }) => {
  const response = await queryClient.ensureQueryData(
    getMinBeginGeldigheidQueryOptions({ bedrijfId })
  );

  return selectMinBeginGeldigheid(response);
};

export const useMinBeginGeldigheid = ({
  bedrijfId,
}: UseMinBeginGeldigheidProps) => {
  return useQuery(getMinBeginGeldigheidQueryOptions({ bedrijfId }));
};
